'use client'

import { useCallback } from 'react'
import type { Cart } from '@booking/types/booking'

import { payTransaction } from '@booking/services/api'

type Args = {
  email: string
}

export function useGatewayPaypal({ email }: Args) {
  const startPaypalPayment = useCallback(
    async ({
      cart,
      successUrl,
      errorUrl,
    }: {
      cart: Cart
      total: number
      successUrl: string
      errorUrl: string
    }) => {
      const res = await payTransaction(cart.id, 'PAYPAL', {
        customerEmail: email,
        successPath: successUrl,
        errorPath: errorUrl,
      })
      if (!res) return
      if (!res.payment.redirect) return
      window.location.assign(res.payment.redirect)
    },
    [email],
  )

  return { startPaypalPayment }
}
